import React, {useEffect, useState} from 'react';
import {DocRow, DocTable, DocTitle} from '../../components';
import {DocumentsBatch, RefpadoDocument, RefpadoResponse} from '../../types';
import {mayBe} from './utils';
import {selectedDocument} from "./index";
import {AvailableDocuments} from "./AvailableDocuments";
import {QRFooter} from "../qr_footer/QRFooter";


export const RefpadoDoc: React.FC<{ documents: DocumentsBatch, withVersions?: boolean }> = ({
                                                                                                documents,
                                                                                                withVersions = true
                                                                                            }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
        {
            document: documents.documents[0],
            documentTypeName: documents.documentsType
        });

    const [doc, setDocument] = useState<RefpadoResponse>(
        selectedDocument.document.document as RefpadoResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as RefpadoResponse);
    }, [selectedDocument.document.version]);


    const title = `Справка о наличии/отсутствии задолженности/переплаты № ${mayBe(doc.refNumber) || 'б/н'}`;
    const subTitle = `Выдана заявителю:`;

    const getDocument = (document: RefpadoDocument) => {
        const {documentType, serial = '', number = '', issuedBy = '', issuedDate = ''} = document;
        if (!serial && !number && !issuedBy && !issuedDate) {
            return documentType;
        }
        return `${documentType} ${serial} №${number}, выдан ${issuedBy} от ${issuedDate}`;
    };

    const servicesTableData = (() => {
        const headers = [
            'Услуга, по которой имеется задолженность/переплата',
            'Размер задолженности/переплаты',
        ];
        const subtitle = `Наименование услуги и сумма задолженности/переплаты по оплате жилого помещения и
    коммунальных услуг на ${doc.refDate} в разрезе услуг (руб.):`;
        const rows = Array.isArray(doc.services)
            ? doc.services.map((service, index) => [service.name, `${service.value}`])
            : [];

        const empty = 'Нет данных';

        return {subtitle, headers, rows, empty};
    })();

    const url = `https://www.mos.ru${process.env.PUBLIC_URL}/${doc.blockchainUid}`;

    return (
        <>
            <div className="col-span-12 md:col-span-12">
                <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
            </div>

            <div className="col-span-12 md:col-span-8">
                <div className="pl-3 pb-5 bottom-line">
                    <DocRow title="Фамилия" value={mayBe(doc.oksInfo.lastName)}/>
                    <DocRow title="Имя" value={mayBe(doc.oksInfo.firstName)}/>
                    <DocRow title="Отчество" value={mayBe(doc.oksInfo.midName)}/>
                    <DocRow title="Дата рождения" value={mayBe(doc.oksInfo.birthdate) || '-'}/>
                    <DocRow title="Документ удостоверяющий личность"
                            value={getDocument(doc.oksInfo.document)}
                    />
                    <DocRow title="Наименование ОИВ/уполномоченного органа"
                            value={mayBe(doc.department) || '-'}
                    />
                    <DocRow title="Зарегистрированному(-ой) по месту жительства по адресу"
                            value={mayBe(doc.oksInfo.regAddress) || '-'}
                    />
                    <DocRow title="В том, что за жилым помещением, расположенным по адресу"
                            value={mayBe(doc.flsAddress) || '-'}
                    />
                    <DocRow title="Код плательщика" bold={true} value={mayBe(doc.flsCode) || '-'}/>
                </div>
            </div>

            {
                withVersions && documents.documents.length > 0 &&
                <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-3">
                    <AvailableDocuments
                        docs={documents}
                        setSelectedDocument={setSelectedDocument}
                        className={'md:-mt-12 mb-5'}
                    />
                </div>
            }

            <div className="col-span-12 md:col-span-8 md:order-last">
                <DocTable {...servicesTableData} className="doc-table--m2"/>

                <QRFooter blockchainUid={doc.blockchainUid}
                          refDate={doc.refDate}
                          mfcInfoName={doc.mfcInfo.name}
                          mfcUserName={doc.mfcUser.name}
                />
            </div>
        </>
    );
};
